import script from "./PersonalNewsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonalNewsPage.vue?vue&type=script&setup=true&lang=ts"

import "./PersonalNewsPage.vue?vue&type=style&index=0&id=41f69b6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41f69b6a"]])

export default __exports__